
import $global from 'stores/global'
import {sendFeedback} from './navbar-defs.js'
import NavbarItem from './navbar-item.vue'
import NavbarList from './navbar-list.vue'
import NavbarProfile from './navbar-profile.vue'

const __default__ = {
  components: {NavbarItem, NavbarList, NavbarProfile},
  props: {
    pinned: {type: Boolean, default: false},
    showPin: {type: Boolean, default: false},
    items: {type: Array, default: () => []}
  },
  emits: ['show', 'feedback-open', 'update:pinned'],
  data(){
    return {
      fb_id: crypto.randomUUID(),
      fb_opened: false
    }
  },
  computed: {
    is_settings(){
      return this.$route.path === '/settings'
    },
    padding(){
      return this.$store.max_style ? '1.8rem 0.8rem 1.6rem' : '3.2rem 0.8rem 1.6rem'
    }
  },
  methods: {
    refresh(){
      this.$refs.scroller?.refresh()
    },
    onFeedbackShow(event){
      this.fb_opened = event.show
      this.$emit('show', event)
      if (event.show) this.$emit('feedback-open')
    },
    closeMobileMenu(){
      if (this.$responsive.mobile) this.$dispatch('toggle-burger')
    },
    onLogo(){
      $global.goToPulse()
      this.closeMobileMenu()
    },
    onNewChat(){
      $global.goToChats()
      this.closeMobileMenu()
    },
    onSend(message){
      return sendFeedback(message)
    }
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "27628490-padding": (_ctx.padding)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__